import { Routes } from "@angular/router";
import { CategoryproductsComponent } from "src/app/categories/categoryproducts/categoryproducts.component";
import { GroupsComponent } from "src/app/main/groups/groups.component";
import { HomeComponent } from "src/app/main/home/home.component";
import { SettingsComponent } from "src/app/main/settings/settings.component";
import { BasecartComponent } from "src/app/order/basecart/basecart.component";
;

export const HOME_ROUTES: Routes = [
    {
      path: 'home', component: HomeComponent
    },
    {
      path: 'settings', component: SettingsComponent
    },
    {
      path: 'groups', component: GroupsComponent
    },
    {
      path: 'cart', component: BasecartComponent
    },
    {
      path: 'categories/sub/products/:id/:title/:type', component: CategoryproductsComponent
  },
]